import { ArrowRightIcon, BodyText, Button, Heading } from '@farol-ds/react'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import { GA4ClickEvent } from '@jusbrasil-web/shared-ga4-events'

import styles from './community-spec-invite.module.scss'

export interface CommunitySpecInviteProps {
  clusterId: string
}

export function CommunitySpecInvite(props: CommunitySpecInviteProps) {
  const { clusterId } = props

  const { sendGA4Event } = useGA4Dispatcher()

  const onButtonClick = () => {
    sendGA4Event(
      new GA4ClickEvent({
        componentName: 'cta',
        componentClass: 'form_button',
        selectedOption: 'opt-in',
        resourceId: clusterId,
      })
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Heading size="sm" className={styles.heading}>
          Quer ser reconhecido como especialista nesse tema?
        </Heading>
        <BodyText size="md" className={styles.bodyText}>
          Compartilhe sua experiência e insights aprofundados sobre essa tese. No Jusbrasil, a maior
          plataforma jurídica do Brasil, sua expertise ganha reconhecimento e impacta milhares de
          profissionais.
        </BodyText>
        <Button
          kind="secondary"
          size="md"
          rightIcon={<ArrowRightIcon />}
          className={styles.button}
          data-testid="community-spec-invite-cta"
          onClick={onButtonClick}
          asChild
        >
          <a
            href="https://jusbrasilpesquisa.typeform.com/teses-juridicas"
            rel="noopener noreferrer"
            target="_blank"
          >
            Quero escrever sobre esse assunto
          </a>
        </Button>
      </div>
    </div>
  )
}
